import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { DateFormatService } from 'dmmp-services'
import { MediaInterface } from '../../../interfaces'

@Component({
  selector: 'dmmp-banner-new',
  templateUrl: './banner-new.component.html'
})
export class BannerNewComponent implements OnInit {
  @Input() path
  @Input() textLink
  @Input() image
  @Input() date
  @Input() title
  @Input() description
  @Input() quantityDescription
  @Input() defaultClass
  @Input() backgroundColorBox
  @Input() opacityBox
  @Output() page = new EventEmitter()

  medias : MediaInterface[] = [
    {style: 'large', media: '(min-width:1301px)'},
    {style: 'max_1300x1300', media: '(min-width:651px) AND (max-width:1300px)'},
    {style: 'max_650x650', media: '(max-width:650px) AND (min-width:326px)'},
    {style: 'max_325x325', media: '(max-width:325px)'},
  ]

  constructor(private dateFormat: DateFormatService) {
  }

  ngOnInit() {
    this.date = this.dateFormat.convertFromTimestampToDate(this.date)
  }
}
